export const BreakLine = (label) => {
	const splitString = label.split('>');
	return (
		<p>
			{splitString[0]} <br /> {splitString[1]}
		</p>
	);
};
